import { render } from "./ModalInfoVeiculo.vue?vue&type=template&id=60f5db87&scoped=true&ts=true"
import script from "./ModalInfoVeiculo.vue?vue&type=script&lang=ts"
export * from "./ModalInfoVeiculo.vue?vue&type=script&lang=ts"

import "./ModalInfoVeiculo.vue?vue&type=style&index=0&id=60f5db87&scoped=true&lang=css"

import exportComponent from "/Users/camp2/Devs/indicar/indicar-gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60f5db87"]])

export default __exports__